import { REPORT } from "@/config/content";

const COLORS = { E: "#b85d3b", C: "#c88a2e", P: "#4a6b56", A: "#44403c" };

export default function ProfileBars({ scores }) {
  const topPts = scores.tiers[0].points;
  const order = scores.tiers.flatMap((t) => t.profiles);
  const tie = scores.tiers.some((t) => t.profiles.length > 1);
  return (
    <div className="rounded-3xl border bg-white p-6 sm:p-8" data-testid="profile-distribution">
      <span className="eyebrow">Suas tendências comportamentais</span>
      <div className="mt-6 space-y-4">
        {order.map((p) => (
          <div key={p} data-testid={`profile-bar-${p}`}>
            <div className="flex items-baseline justify-between text-sm">
              <span className={`text-stone-800 ${scores.points[p] === topPts ? "font-semibold" : ""}`}>{scores.names[p]}</span>
              <span className="font-mono text-xs text-stone-500">{scores.points[p]} pts · {scores.shares[p].toLocaleString("pt-BR")}%</span>
            </div>
            <div className="mt-1.5 h-2.5 rounded-full bg-stone-100">
              <div className="h-full rounded-full" style={{ width: `${(scores.points[p] / 44) * 100}%`, background: COLORS[p] }} />
            </div>
          </div>
        ))}
      </div>
      <p className="mt-5 text-xs leading-relaxed text-stone-500">{REPORT.sharesNote}{tie ? ` ${REPORT.tieNote}` : ""}</p>
    </div>
  );
}
